import { JRCTypography } from 'components/JRCTypography/JRCTypography';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

export type Step = {
    label: string | React.ReactNode;
    onClick?: (step: number) => void;
};

/**
 * @member steps array of steps
 * @member activeStep active step of the stepper. Starts at 0.
 */
export type JRCStepperProps = {
    steps?: Array<Step>;
    activeStep: number;
};

const Item = styled.div<{ active: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 8px ${(props) => (props.active ? '0' : '8px')} 8px 0;
    padding: 8px;
    transition: all 0.2s;
`;

const Circle = styled.div<{ active: boolean }>`
    width: ${(props) => (props.active ? '16px' : '8px')};
    height: ${(props) => (props.active ? '16px' : '8px')};
    border-radius: 50%;
    background-color: ${(props) => (props.active ? props.theme.color.primary : props.theme.color.primaryL80)};
    transition: all 0.2s;
`;

export function JRCStepper(props: JRCStepperProps) {
    return (
        <div>
            {props.steps?.map?.(({ label, onClick }, index) => (
                <Item
                    as={onClick ? 'button' : 'div'}
                    onClick={onClick ? () => onClick(index) : undefined}
                    active={index === props.activeStep}
                    key={index}>
                    <Circle active={index === props.activeStep} />
                    <JRCTypography size="l" color={index === props.activeStep ? 'grey6' : 'grey4'}>
                        {typeof label === 'string' ? <FormattedMessage id={label} /> : label}
                    </JRCTypography>
                </Item>
            ))}
        </div>
    );
}
